/*       */

import { gql } from '@apollo/client';

export default gql`
    query loadWorkspaceUsersByPrivateTeam($workspaceId: ID!) {
        result: workspaceTeamMembers(
            filterBy: [
                { field: "workspace", op: "=", value: $workspaceId }
                { field: "team.isSystem", op: "=", value: true }
                { field: "team.workspace.id", op: "=", value: $workspaceId }
            ]
        ) {
            team {
                id
                name
                users {
                    role
                    user {
                        id
                        name
                        image
                        username
                    }
                }
            }
        }
    }
`;
